<style>
  .sharable-buttons {
    display: none;
    padding: 5px 0;
    border-top: 1px solid #bbb;
  }
  .sharable-buttons.expanded {
    display: flex;
    justify-content: space-around;
  }

  .home-container {
    //padding-top: 25px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .home-container .v-card__title :first-child {
    font-size: 18px;
  }
  .home-container .v-card__title :nth-child(2) {
    font-size: 16px;
  }
  .home-container .v-card__title :last-child {
    font-size: 18px;
  }

  @media only screen and (max-width: 481px) {
    .home-container .v-card__title :first-child {
      font-size: 5vw;
    }
    .home-container .v-card__title :nth-child(2) {
      font-size: 4vw;
    }
    .home-container .v-card__title :last-child {
      font-size: 5vw;
    }
    .home-container {
      /*padding: 20px 20px;*/
    }
  }

  .home-container__prompt {
    text-align: center;
    font-size: 22px;
    color: #767676;
    //line-height: 1.4;
    max-width: 90%;
    @media (min-width: 800px) {
      //margin: 20px 0;
      max-width: inherit;
    }
  }

  .isCentered {
    justify-content: center;
  }


  .templates-recent, .templates-gallery {
    font-size: 20px;
    color: #565656;
    margin-bottom: 20px;
    text-align: center;
    @media (min-width: 1264px) {
      text-align: left;
    }
  }

  .templates-gallery {
    margin-top: 0;
    @media (min-width: 800px) {
      margin-top: 0;
    }
  }

  .v-tabs .v-slide-group__prev, .v-tabs .v-slide-group__next {
    display: none !important;
  }

</style>

<template>
  <v-container fluid>
    <div class="home-container">
      <div v-if="$store.state.user.templates.length > 0">
        <div style="display: flex;">
          <v-tabs centered v-model="tab" background-color="transparent">
            <v-tab>{{ translate('ui_templates__recent') }} ({{ templates.length }})</v-tab>
            <v-tab>{{ translate('nav_templates') }}</v-tab>
          </v-tabs>
        </div>

        <div
          v-if="!$store.getters.userCanAddNewTemplates"
          style="text-align: center;"
        >
          <v-alert
            dense
            style="border: 1px solid #fb8c00; margin: 20px auto 0; display: inline-block;"
          >
            <div style="display:flex; align-items: start; justify-content: center; gap: 10px; font-size: 13px; text-align: center; color: #fb8c00;">
              <v-icon style="color: #fb8c00; font-size: 20px;">mdi-alert</v-icon>
              <span v-html="translate('ui_user_max_templates_reached')"></span>
            </div>
          </v-alert>
        </div>

        <v-tabs-items v-model="tab" style="background: transparent; margin-top: 30px;">
          <v-tab-item style="padding: 40px 0 0;">
            <div class="templates-recent">
              <v-row style="justify-content: center; gap: 50px;">
                <TemplateGalleryItem templateType="new">
                  <template v-slot:content>
                    <div v-if="tab === 0">
                      <v-btn-toggle v-model="displayMode">
                        <v-btn value="grid" small>
                          <v-icon>mdi-view-grid</v-icon>
                        </v-btn>
                        <v-btn value="list" small>
                          <v-icon>mdi-view-list</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </div>
                  </template>
                </TemplateGalleryItem>
                <v-col cols="12" md="9" lg="9">
                  <v-row v-if="displayMode === 'list'" class="row--dense">
                    <TemplateGalleryListItem v-for="(template, i) in templates" :key="i" :template="template" templateType="user"/>
                  </v-row>
                  <v-row v-if="displayMode === 'grid'">
                    <TemplateGalleryItem v-for="(template, i) in templates" :key="i" :template="template" :displayMode="displayMode" templateType="user"/>
                  </v-row>
                </v-col>
              </v-row>
            </div>
          </v-tab-item>

          <v-tab-item style="padding: 40px 0 0 ;">
            <v-row style="justify-content: center; gap: 50px;">
              <v-col cols="12">
                <TemplateStaticGallery/>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </div>

      <div v-if="$store.state.user.templates.length === 0">
        <v-row>
          <v-col cols="12">
            <div class="home-container__prompt">
              <div v-html="addNewTemplateIntro"></div>
              <v-row style="justify-content: center; margin-top: 30px;">
                <TemplateGalleryItem templateType="new"/>
              </v-row>
            </div>
          </v-col>

          <v-col>
            <div class="home-container__prompt" style="margin-top: 30px;">
              <div v-html="addNewTemplateIntro2"></div>
            </div>

            <v-row style="margin-top: 30px">
              <v-col cols="12" md="9" lg="9" style="margin: 0 auto;">
                <TemplateStaticGallery/>
              </v-col>
            </v-row>

          </v-col>

        </v-row>

      </div>

      <v-snackbar
        color="white"
        :value="selectedTemplates.length > 0"
        timeout="-1"
        min-width="400"
      >
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="color: #373030; font-weight: bold; font-size: 16px;">
            {{ selectedTemplates.length }} {{ this.translate('ui_items_selected') }}
          </div>
          <v-btn
            color="red"
            outlined
            @click="deleteSelectedTemplates"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
            {{ this.translate('ui_delete_btn') }}
          </v-btn>
        </div>
      </v-snackbar>

    </div>
  </v-container>
</template>

<script>
// import store from '@/store';
import TemplateGalleryItem from '@/components/gallery/TemplateGalleryItem';
import TemplateGalleryListItem from '@/components/gallery/TemplateGalleryListItem.vue';
import TemplateStaticGallery from '../components/gallery/TemplateStaticGallery.vue';
// mixins
import Mixin from '../mixins/mixin';


export default {
  name: 'Home',
  components: {
    TemplateGalleryListItem,
    TemplateStaticGallery,
    TemplateGalleryItem,
  },
  data: () => ({
    displayMode: 'grid',
    tab: 0,
  }),
  props: {},
  mixins: [Mixin],
  methods: {
    deleteSelectedTemplates() {
      const { templates } = this.$store.state.user;
      const templatesToRemove = templates.filter((template) => template.isSelected);
      templatesToRemove.forEach((template, index) => {
        // hot fix to server not removing all templates when rapid-firing them
        setTimeout(() => {
          this.$store.dispatch('removeTemplate', { template, skipPrompt: true });
        }, index * 500);
      });
      /*
      this.$store.dispatch('updateState', {
        path: 'user.templates',
        value: templatesToStay,
      });
      this.$store.dispatch('saveUser', true);
      // also delete activeTemplate if it was deleted
      if (!templatesToStay.find((template) => template.uuid === this.$store.state.activeTemplate.uuid)) {
        this.$store.dispatch('updateState', {
          path: 'activeTemplate',
          value: null,
        });
      }
       */
    },
    loadUserTemplate(template) {
      console.dir(template);
      const newTemplate = JSON.parse(JSON.stringify(template));
      const newTemplateUUID = this.uuidv4();
      newTemplate.uuid = newTemplateUUID;
      this.$store.commit('addTemplate', newTemplate);
      this.$router.push(`/template/${newTemplateUUID}`);
    },
  },
  computed: {
    selectedTemplates() {
      return this.$store.state.user.templates.filter((template) => template.isSelected);
    },
    addNewTemplate() {
      const { language } = this.$store.state.user.settings;
      let result = '';
      if (this.$store.state.languages) {
        result = this.translate('ui_add_new_template_btn', language);
      }
      return result;
    },
    addNewTemplateIntro() {
      const { language } = this.$store.state.user.settings;
      let result = '';
      if (this.$store.state.languages) {
        result = this.translate('ui_add_new_template_intro', language);
      }
      return result;
    },
    addNewTemplateIntro2() {
      const { language } = this.$store.state.user.settings;
      let result = '';
      if (this.$store.state.languages) {
        result = this.translate('ui_add_new_template_intro2', language);
      }
      return result;
    },
    templates() {
      // sort newest on top
      // eslint-disable-next-line
      const templates = this.$store.state.user.templates.sort((a, b) => b.timestamp - a.timestamp);
      return templates;
    },
  },
  mounted() {
    // refresh user data i.e. template name was updated
    // store.dispatch('getUserData');
  },
};
</script>
